import { ENV } from '@forwardflow/helpers/configs/envConfig'

export type TVoiceOption = {
   voiceId: string
   name: string
   description: string
   avatar: string
   gender: string
   previewUrl?: string
}

const ELEVENLABS_VOICES: TVoiceOption[] = [
   {
      voiceId: 'P7x743VjyZEOihNNygQ9',
      name: 'Dakotah',
      description: 'Warm and unhurried',
      avatar:
         'https://forward-flow-assets.s3.us-west-2.amazonaws.com/campaign-avatars/assistant-4.png',
      gender: 'female',
   },
   {
      voiceId: 'f5HLTX707KIM4SzJYzSz',
      name: 'Bradward',
      description: 'Clear and direct',
      avatar:
         'https://forward-flow-assets.s3.us-west-2.amazonaws.com/campaign-avatars/assistant-2.png',
      gender: 'male',
   },
]
const GEMINI_VOICES: TVoiceOption[] = [
   {
      voiceId: 'Sulafat',
      name: 'Sulafat',
      description: 'Warm and unhurried',
      avatar:
         'https://forward-flow-assets.s3.us-west-2.amazonaws.com/campaign-avatars/assistant-4.png',
      gender: 'female',
   },
   {
      voiceId: 'Umbriel',
      name: 'Umbriel',
      description: 'Clear and direct',
      avatar:
         'https://forward-flow-assets.s3.us-west-2.amazonaws.com/campaign-avatars/assistant-2.png',
      gender: 'male',
   },
]

/** The static pair shown when the voice service returns nothing. */
export const FALLBACK_VOICES: TVoiceOption[] =
   ENV.VOICE_PROVIDER === 'gemini' ? GEMINI_VOICES : ELEVENLABS_VOICES
